(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aureline-marquee"] && !Shopify.designMode) return;
  try {
    
(() => { const init = (root = document) => root.querySelectorAll('[data-al-marquee]').forEach(bar => { if (bar.dataset.ready) return; bar.dataset.ready='true'; const toggle=bar.querySelector('[data-al-marquee-toggle]'); toggle.addEventListener('click',()=>{const paused=bar.classList.toggle('is-paused');toggle.setAttribute('aria-label',paused?bar.dataset.playLabel:bar.dataset.pauseLabel);toggle.innerHTML=paused?'<svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="m5 3 8 5-8 5z"/></svg>':'<svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M4 3h2v10H4zM10 3h2v10h-2z"/></svg>';}); }); if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();document.addEventListener('shopify:section:load',e=>init(e.target)); })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aureline-newsletter"] && !Shopify.designMode) return;
  try {
    
(() => {
 const key='aureline-newsletter-until-v1', sessionKey='aureline-newsletter-seen-v1';
 const safeRead=(storage,k)=>{try{return window[storage].getItem(k)}catch(_){return null}};
 const safeWrite=(storage,k,v)=>{try{window[storage].setItem(k,v)}catch(_){}};
 const init=(root=document)=>root.querySelectorAll('[data-al-newsletter]').forEach(section=>{
  if(section.dataset.ready)return;section.dataset.ready='true';
  const dialog=section.querySelector('dialog');if(!dialog?.showModal)return;
  const success=!!section.querySelector('[data-al-newsletter-success]'), errors=!!section.querySelector('[data-al-newsletter-errors]');
  const days=Number(section.dataset.repeat)||30;
  let lastFocus, timer, check;
  const suppress=(daysToStore=days)=>{safeWrite('localStorage',key,String(Date.now()+daysToStore*86400000));safeWrite('sessionStorage',sessionKey,'1')};
  const open=()=>{if(dialog.open)return;lastFocus=document.activeElement;dialog.showModal();safeWrite('sessionStorage',sessionKey,'1');clearTimeout(timer);clearInterval(check)};
  const close=()=>{suppress(success?365:days);dialog.close();lastFocus?.focus?.();if(success){try{const url=new URL(location.href);url.searchParams.delete('customer_posted');url.hash='';history.replaceState(history.state,'',url.href)}catch(_){}}};
  section.querySelectorAll('[data-al-newsletter-open]').forEach(b=>b.addEventListener('click',open));
  section.querySelectorAll('[data-al-newsletter-close]').forEach(b=>b.addEventListener('click',close));
  dialog.addEventListener('cancel',event=>{event.preventDefault();close()});
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close()});
  if(success){suppress(365);open();return}if(errors){open();return}
  const suppressed=Number(safeRead('localStorage',key)||0)>Date.now()||safeRead('sessionStorage',sessionKey)==='1';
  if(section.dataset.autoshow!=='true'||section.dataset.existingSubscriber==='true'||suppressed||window.Shopify?.designMode||/\/(cart|checkout|checkouts|challenge|account|password)(\/|$)/.test(location.pathname))return;
  timer=setTimeout(()=>{let tries=0;check=setInterval(()=>{if(++tries>60||!section.isConnected){clearInterval(check);return}const active=document.activeElement;const cookieBanner=document.querySelector('#shopify-pc__banner');const cookieVisible=cookieBanner&&getComputedStyle(cookieBanner).display!=='none';if(document.hidden||document.querySelector('dialog[open]')||cookieVisible||active?.matches('input,textarea,select'))return;open()},1000)},Number(section.dataset.delay)||18000);
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(section)){clearTimeout(timer);clearInterval(check)}},{once:true});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
